var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandluggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 546 893",
    style: {
      enableBackground: "new 0 0 546 893"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M482.9,797.9h-63v31.5c0,17.4,14.1,31.5,31.5,31.5c17.4,0,31.5-14.1,31.5-31.5V797.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.1,797.9h-63v31.5c0,17.4,14.1,31.5,31.5,31.5c17.4,0,31.5-14.1,31.5-31.5V797.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M545.9,252.1v398.9c0,57.9-47,105-105,105H105.1c-57.9,0-105-47-105-105V252.1c0-57.9,47-105,105-105h335.9 C498.9,147.1,545.9,194.1,545.9,252.1z M252,315v272.9c0,11.6,9.4,21,21,21c11.6,0,21-9.4,21-21V315c0-11.6-9.4-21-21-21 C261.4,294.1,252,303.5,252,315z M84.1,315v272.9c0,11.6,9.4,21,21,21c11.6,0,21-9.4,21-21V315c0-11.6-9.4-21-21-21 C93.5,294.1,84.1,303.5,84.1,315z M420,315v272.9c0,11.6,9.4,21,21,21c11.6,0,21-9.4,21-21V315c0-11.6-9.4-21-21-21 C429.4,294.1,420,303.5,420,315z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336,21.1c0-11.6-9.4-21-21-21h-84c-11.6,0-21,9.4-21,21v84h126V21.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandluggage);
export default __webpack_public_path__ + "static/media/Handluggage.6ca26aff7fbaaae28ff577652376bc91.svg";
export { ForwardRef as ReactComponent };